import styled from "styled-components";

import { Grid } from "@mui/material";
import BannerImg from "../../assets/cangoo-sobre-banner.jpg"

export const BannerGrid = styled(Grid)`

background: url(${BannerImg});
background-repeat: no-repeat;
background-position: bottom center; 
background-size: cover; 

 padding-top: 24rem;
 padding-bottom: 10rem;

 @keyframes fadeIn {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}

.title {
    position: relative;
    width: fit-content;
    display: flex;

    
    margin-left: 10rem;
    animation: fadeIn 2s ease-in-out;

    h1 {
        font-family: 'Nexa-Black'; 
        font-size: 8rem;
        color: ${({ theme }) => theme.COLORS.WHITE};
        letter-spacing: 1px;
        padding-right: 4rem;
        padding-bottom: 2rem;
    }

    img {
        width: 15rem;
        position: absolute;
        right: 0;
      
    }
}


@media (max-width: 1400px) {
   .title {

    h1 { 
        font-size: 5rem;
        padding-right: 3rem;
        
    }

    img {
        width: 10rem;  
        bottom: 0;
    }
   }
  }

 
  @media (max-width: 900px) {
    padding-top: 20rem;
    padding-bottom: 6rem;

   .title {
    margin-left: auto;
    margin-right: auto;

    h1 { 
        font-size: 4rem;
        padding-right: 3rem;
        padding-bottom: 2rem;
    }

    img {
        width: 8rem;  
        bottom: 0;
    }
   }
  }


  @media (max-width: 550px) {
   .title {
    padding-left: 1rem;
    padding-right: 1rem;

    h1 { 
        font-size: 3rem;
        padding-right: 1rem;
    }

    img {
        width: 6rem;  
        bottom: .5rem;
    }
   }
  }

  `;



export const Section1 = styled(Grid)`
padding:10rem 20rem;
padding-right: 6rem;
animation: fadeIn 1s ease-in-out;


.sideA {
    display: flex;
    flex-direction: column;
    padding-right: 4rem;
    
    h1 {
        font-family: 'Nexa-Bold';
        color: ${({ theme }) => theme.COLORS.LIGHTBLUE2};
        font-size: clamp(2.4rem, 4vw, 8rem);   
        letter-spacing: 1px;
    }

    h2 {
        font-family: 'Nexa-Bold';
        color: ${({ theme }) => theme.COLORS.YELLOW};
        font-size: clamp(2.4rem, 10vw, 12rem);
        letter-spacing: 1px;
        margin-bottom: 4rem;
    }

    p {
        font-family: 'Mont-Light';
        font-size: clamp(1.6rem, 3.4vw, 3rem); 
    }

    span {
        font-family: 'Mont-Bold';
        font-size: clamp(1.6rem, 3.4vw, 3rem); 
    }

    .yellow {
        color: ${({ theme }) => theme.COLORS.YELLOW};  
    }
}

.sideB {
    text-align: right;

    img {
        width: clamp(30rem, 36vw, 70rem); 
    }
}



@media (max-width: 1400px) {
    padding:10rem 10rem;
    padding-right: 6rem;

   .sideA {
    padding-right: 0;

    h1 {
        font-size: clamp(2.6rem, 3.4vw, 5rem);
    }

    h2 {
        font-size: clamp(2.4rem, 10vw, 7rem);
    }

    span {
        font-size: clamp(1.8rem, 3.4vw, 2.2rem);
    }

    p {
        font-size: clamp(1.8rem, 3.4vw, 2.2rem); 
    }
   }
}


@media (max-width: 1200px) {
  .sideB {
   display: flex;
   align-items: center;
   justify-content: end;
  }
}

@media (max-width: 900px) {
  padding:10rem 2rem;
  text-align: center;

  .sideB {
    display: none;
  }
}


@media (max-width: 600px) {
  padding-top: 6rem;
}
 
 
`;


export const Section2 = styled(Grid)`
padding-left: 4rem;
padding-right: 10rem;
padding-bottom: 10rem;

.sideA {
    img {
        width: clamp(24rem, 36vw, 70rem); 
    }
}


.sideB {
    h1 {
        font-family: 'Nexa-Bold';
        color: ${({ theme }) => theme.COLORS.LIGHTBLUE2};
        font-size: clamp(2.4rem, 4vw, 8rem);   
        letter-spacing: 1px;
    }

    p {
        font-family: 'Mont-Light';
        font-size: clamp(1.6rem, 3.4vw, 3rem);
        margin-top: 4rem; 
    }

    span {
        font-family: 'Mont-Bold';
        font-size: clamp(1.6rem, 3.4vw, 3rem); 
    }

    .yellow {
        color: ${({ theme }) => theme.COLORS.YELLOW};  
    }
}


@media (max-width: 1400px) {
    padding-right: 4rem;

    .sideA {
        display: flex;
        align-items: center;
    }

    .sideB {
    h1 {
        font-size: clamp(2.6rem, 3.4vw, 5rem);
    }


    span {
        font-size: clamp(1.8rem, 3.4vw, 2.2rem);
    }

    p {
        font-size: clamp(1.8rem, 3.4vw, 2.2rem); 
    }
    }
}


@media (max-width: 900px) {
    text-align: center;
    padding-left: 2rem;
    padding-right: 2rem;

    .sideA {
        justify-content: center;
        margin-bottom: 2rem;
    }
}
 
`;



export const Section3 = styled(Grid)`
margin: 14rem 0;
background: ${({ theme }) => theme.COLORS.BACKGROUND_BLUE};
padding: 0 10rem;


.hide {
    display: none;
}

.icons-top {
    text-align: center;
    margin-top: -10rem;
}

img {
        display: block;
        margin-left: auto;
        margin-right: auto;
    }

h1 {
    font-family: 'Nexa-Bold';
    color: ${({ theme }) => theme.COLORS.YELLOW};  
    font-size: clamp(1.6rem, 3.4vw, 4.4rem); 
    margin-top: 6rem;
    margin-bottom: 2rem;
}

p {
    font-family: 'Mont-Light';
    font-size: clamp(1.6rem, 3.4vw, 2.8rem); 
    color: ${({ theme }) => theme.COLORS.WHITE};  
}


.sideA {
   padding-right: 4rem;
}

.sideB {
    border-left: 2px solid white;
    border-right: 2px solid white;
    padding: 0 4rem;
}

.sideC {
    padding-left: 4rem;
}

.bottom {
    height: 4rem;
}


@media (max-width: 1400px) {
    padding: 0 6rem;

    h1 {
        font-size: clamp(2.4rem, 3.4vw, 3.2rem); 
}

p {
    font-size: clamp(1.6rem, 3.4vw, 2rem); 
}

.icons-top {
    margin-top: -8rem;

    img {
        width: 14rem;
    }
} 

.sideA {
   padding-right: 2rem;
}

.sideB {
    border-left: 2px solid white;
    border-right: 2px solid white;
    padding: 0 2rem;
}

.sideC {
    padding-left: 2rem;
}
}


@media (max-width: 1200px) {
    padding: 0 4rem;
}


@media (max-width: 900px) {
    text-align: center;
    margin-top: 4rem;
    margin-bottom: 10rem;

    .bottom {
    height: 6rem;
}


    .icons-top {
        display: none;
    }
    
    .icons-bottom {
        display: inherit;
        width: 14rem;
        margin-top: 6rem;
    }

    
    h1 {
        margin-top: 2rem;
    }


.sideA {
   padding-right: 0;
}

.sideB {
    border-left: none;
    border-right: none;
    padding: 0;
}

.sideC {
    padding-left: 0;
}
}


@media (max-width: 500px) {
    padding: 0 2rem;


    .icons-bottom {
        width: 10rem;
    }
}
`;


export const FormGrid = styled(Grid)`

padding-bottom: 14rem;

.text {
    text-align: center;
    margin-bottom: 2rem;

    h1 {
        font-size: clamp(2.4rem, 3.4vw, 5.2rem); 
        font-family: 'Nexa-Bold';
        margin-bottom: 1.8rem;
        letter-spacing: 1px;
        color: ${({ theme }) => theme.COLORS.LIGHTBLUE2};
    }

    p {
        font-family: 'Mont-Light';
        font-size: clamp(1.6rem, 3.4vw, 2.4rem); 
    }
}

.form {
    margin-left: auto;
    margin-right: auto;
}


@media (max-width: 1400px) {
    .text {
        padding: 0 2rem;

        h1 {
    font-size: clamp(2.6rem, 3.4vw, 4.2rem); 
    margin-bottom: 1rem;
}

p {
    font-size: clamp(1.8rem, 3.4vw, 2.2rem); 
}
    }
}


@media (max-width: 900px) {
    padding-bottom: 10rem;
}

`;

